import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = [{
  title: 'El Protocolo Maestro de 7 Días',
  description: 'Tu hoja de ruta exacta de qué comer y beber desde que despiertas hasta que duermes.'
}, {
  title: 'El Botiquín de la Abuela',
  description: 'Cómo usar la Cúrcuma, Jengibre y Canela en dosis terapéuticas para desinflamar.'
}, {
  title: 'Lista de Compras USA',
  description: 'Guía específica para comprar lo correcto en Walmart, Aldi o Target sin gastar de más.'
}, {
  title: 'Ritual de 3 Minutos',
  description: 'Movimientos linfáticos sencillos que puedes hacer mientras cocinas para drenar líquidos.'
}, {
  title: 'Guía de Supervivencia en Restaurantes',
  description: 'Qué pedir en el sitio mexicano o cubano para disfrutar sin amanecer hinchada.'
}];
export function BenefitsSection() {
  return <section className="py-20 px-4 bg-base" data-id="element-21">
      <div className="max-w-5xl mx-auto" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-3xl md:text-4xl text-primary mb-4" data-id="element-24">
            Todo lo que recibes hoy
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-25" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-26">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-2 md:order-1" data-id="element-27">
            <div className="space-y-6" data-id="element-28">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-4 bg-white p-5 rounded-2xl shadow-sm border border-sage hover:border-accent/50 transition-colors" data-id="element-29">
                  <CheckCircle2 className="w-7 h-7 text-primary shrink-0 mt-0.5" data-id="element-30" />
                  <div data-id="element-31">
                    <h4 className="font-bold text-ink text-lg mb-1" data-id="element-32">
                      {benefit.title}
                    </h4>
                    <p className="text-ink/70 text-sm leading-relaxed" data-id="element-33">
                      {benefit.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-1 md:order-2 relative" data-id="element-34">
            <div className="absolute inset-0 bg-accent/10 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-35"></div>
            <img src="https://cdn.magicpatterns.com/uploads/f6nEyr9JRHGX8v4wYFs846/Cero_inflamacion_7D.png" alt="Contenido del Protocolo" className="w-full max-w-md mx-auto rounded-2xl shadow-xl transform rotate-2" data-id="element-36" />
          </motion.div>
        </div>
      </div>
    </section>;
}